import type { ModerationComment } from '../../../shared/api/comment-moderation.api';

/**
 * Очередь на удаление и уборка списка после него.
 *
 * Вынесено из компонента, потому что оба правила неочевидны и проверяются
 * тестами: пачка ограничена сверху, а удаление родителя уносит ответы, которых
 * в ответе сервера нет — сервер о них не знает, запросов по ним не было.
 */

/**
 * Первые `size` отмеченных: сначала родители.
 *
 * Родитель забирает ветку с собой, поэтому его удаление закрывает часть
 * очереди. Обратный порядок стоил бы лишних запросов к Instagram — а лимит
 * там на запросы, а не на удалённые комментарии.
 */
export function nextBatch(
  comments: ModerationComment[],
  selected: Set<string>,
  size: number,
): ModerationComment[] {
  const picked = comments.filter((c) => selected.has(c.id));
  const parents = picked.filter((c) => !c.parentId);
  const replies = picked.filter((c) => c.parentId);
  return [...parents, ...replies].slice(0, size);
}

/**
 * Список без того, чего в Instagram больше нет: удалённого, уже отсутствовавшего
 * и ответов под удалёнными родителями.
 *
 * Ответы уходят вместе с родителем, но в `deleted` их нет, и без этой уборки
 * они оставались бы на экране с пометкой «уйдёт с родителем» — как будто их
 * ещё можно удалить.
 */
export function withoutGone(comments: ModerationComment[], goneIds: string[]): ModerationComment[] {
  const gone = new Set(goneIds);
  // Ветки бывают глубже одного уровня, поэтому идём, пока список сокращается.
  for (let pass = 0; pass < comments.length; pass++) {
    const before = gone.size;
    for (const c of comments) {
      if (c.parentId && gone.has(c.parentId)) gone.add(c.id);
    }
    if (gone.size === before) break;
  }
  return comments.filter((c) => !gone.has(c.id));
}
